import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sw-button',
  standalone: true,
  template: `
    <button
      [disabled]="disabled"
      (click)="clicked.emit()"
      [class]="'sw-btn ' + variant"
      [class.is-disabled]="disabled">
      <ng-content />
    </button>
  `,
  styles: [`
    .sw-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      padding: 9px 20px;
      border-radius: 999px;
      font-family: var(--font-mono);
      font-size: 9px;
      font-weight: 700;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      cursor: pointer;
      border: none;
      transition: all 0.2s;
      white-space: nowrap;
    }
    .sw-btn:active:not(:disabled) { transform: scale(0.95); }
    .sw-btn:disabled, .sw-btn.is-disabled { opacity: 0.4; cursor: not-allowed; }

    .sw-btn.primary {
      background: var(--cyan);
      color: var(--obsidian);
      box-shadow: 0 0 20px rgba(0,210,255,0.3);
    }
    .sw-btn.primary:hover:not(:disabled) {
      background: #fff;
      box-shadow: 0 0 30px rgba(255,255,255,0.4);
    }
    .sw-btn.secondary {
      background: rgba(255,255,255,0.03);
      color: var(--white);
      border: 1px solid var(--border-s);
    }
    .sw-btn.secondary:hover:not(:disabled) { background: rgba(255,255,255,0.08); }
    .sw-btn.ghost {
      background: transparent;
      color: var(--grey);
      border: 1px solid var(--border);
    }
    .sw-btn.ghost:hover:not(:disabled) { color: var(--cyan); border-color: var(--cyan-border); }
    .sw-btn.danger {
      background: rgba(239,68,68,0.1);
      color: #f87171;
      border: 1px solid rgba(239,68,68,0.2);
    }
    .sw-btn.danger:hover:not(:disabled) { background: rgba(239,68,68,0.2); }
  `],
})
export class SwButtonComponent {
  @Input() variant: 'primary' | 'secondary' | 'ghost' | 'danger' = 'primary';
  @Input() disabled = false;
  @Output() clicked = new EventEmitter<void>();
}
